$(document).on('click', '[data-remove-parent]', function (e) {
  e.preventDefault();
  var parentSelector = $(this).data('remove-parent');
  var parent = $(this).closest(parentSelector);
  parent.fadeOut(300, function () { parent.remove(); });
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dom/remove-parent.js